// CURRO FUERA · small, dependency-free behaviour: config links, honest checkout state, reveals, scroll walker.
(function () {
  const C = window.CF_CONFIG || {};
  const $$ = (s) => Array.from(document.querySelectorAll(s));

  // price + social links + email
  $$('[data-price]').forEach((el) => (el.textContent = C.PACK_PRICE || el.textContent));
  $$('[data-tiktok]').forEach((a) => (a.href = C.TIKTOK_URL));
  $$('[data-instagram]').forEach((a) => (a.href = C.INSTAGRAM_URL));
  $$('[data-email]').forEach((a) => { a.href = 'mailto:' + C.CONTACT_EMAIL; a.textContent = C.CONTACT_EMAIL; });

  // checkout: only a real URL makes the buy button work. No URL → honest "coming soon" state.
  $$('[data-checkout]').forEach((a) => {
    if (C.PACK_CHECKOUT_URL) {
      a.href = C.PACK_CHECKOUT_URL;
      if (/^https?:/.test(C.PACK_CHECKOUT_URL)) { a.target = '_blank'; a.rel = 'noopener'; }   // same-store checkout stays in this tab
    } else {
      a.removeAttribute('href');
      a.setAttribute('aria-disabled', 'true');
      a.textContent = 'Muy pronto';
      $$('[data-checkout-note]').forEach((n) => (n.hidden = false));
    }
  });

  // community: stays "próximamente" until a real link exists
  if (C.COMMUNITY_URL) {
    $$('[data-community-soon]').forEach((el) => (el.hidden = true));
    $$('[data-community-link]').forEach((a) => {
      a.hidden = false;
      a.href = C.COMMUNITY_URL;
      a.target = '_blank';
      a.rel = 'noopener';
      if (C.COMMUNITY_PLATFORM) a.textContent = 'Entrar en la comunidad (' + C.COMMUNITY_PLATFORM + ') →';
    });
  }

  // paid products: a required consent box (refund policy) unlocks the buy buttons of its section; then the product
  // goes to a clean cart with the consent text saved as an order attribute, and straight to checkout
  // (v5.0: a box inside a product card (.opt) only unlocks the button of that card)
  $$('[data-consent-box]').forEach((box) => {
    const sec = box.closest('.opt') || box.closest('section');
    const btns = Array.from(sec.querySelectorAll('[data-buy]'));
    const sync = () => btns.forEach((b) => b.setAttribute('aria-disabled', box.checked ? 'false' : 'true'));
    box.addEventListener('change', sync);
    sync();
  });
  $$('[data-buy]').forEach((b) => b.addEventListener('click', async (e) => {
    e.preventDefault();
    if (b.getAttribute('aria-disabled') === 'true') return;
    b.setAttribute('aria-disabled', 'true');
    // subscriptions (VIP): the Telegram username is required, so we can send the one-use invite link
    const tg = b.closest('section').querySelector('[data-tg]');
    const user = tg ? tg.value.trim().replace(/^@?/, '@') : '';
    if (tg && !/^@[A-Za-z0-9_]{5,32}$/.test(user)) {
      b.setAttribute('aria-disabled', 'false');
      tg.focus();
      alert('Escribe tu usuario de Telegram (por ejemplo @tunombre). Lo ves en Telegram → Ajustes.');
      return;
    }
    const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    try {
      const item = { id: Number(b.dataset.buy), quantity: 1 };
      if (b.dataset.plan) item.selling_plan = Number(b.dataset.plan);
      const attributes = { Consentimiento: b.dataset.consent + ' (' + new Date().toISOString() + ')' };
      if (tg) attributes.Telegram = user;
      await post('/cart/clear.js', {});
      await post('/cart/add.js', { items: [item] });
      await post('/cart/update.js', { attributes });
      location.href = '/checkout';
    } catch (err) {
      b.setAttribute('aria-disabled', 'false');
      alert('No se ha podido abrir el pago. Inténtalo otra vez.');
    }
  }));

  // reveal on scroll
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;
  $$('.reveal').forEach((el) => (io ? io.observe(el) : el.classList.add('in')));

  // sticky "Pack gratis" bar (phones): shows after the hero, hides while the hero or the footer is visible
  const bar = document.querySelector('[data-sticky-cta]');
  const hero = document.getElementById('pack');
  if (bar && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(hero);
  }

  // Curro walks along the bottom as you scroll
  const curro = document.querySelector('.walker-curro');
  if (curro) {
    let ticking = false;
    const nav = document.querySelector('.nav');
    const setNav = () => document.documentElement.style.setProperty('--nav-h', (nav ? nav.offsetHeight : 57) + 'px');
    setNav();
    const move = () => {
      const max = document.documentElement.scrollHeight - innerHeight;
      const p = max > 0 ? scrollY / max : 0;
      curro.style.setProperty('--walk', (p * (innerWidth - curro.offsetWidth)) + 'px');
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(move); } }, { passive: true });
    addEventListener('resize', () => { setNav(); move(); });
    move();
  }
})();
